// INITS
import Vue from "vue";
import Vuex from "vuex";

// MODULES
import pedido from "./modules/pedido"


const modules = {
	pedido
};

const state = {};
const getters = {};
const mutations = {};
const actions = {};

Vue.use(Vuex);

export const store = new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
	modules
});



// WEBPACK FOOTER //
// ./src/store/init.js